import type { VehicleTemplateType } from '../enums/VehicleTemplateType'

export class VehicleTemplateFilterEntity {
  type?: VehicleTemplateType
  maxConcurrentShipment?: number
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  searchWord?: string
}
